var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-listagem" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c(
                "Pesquisa",
                {
                  attrs: {
                    placeHolder:
                      "Informe o nome da Gleba, município ou nº do Processo",
                    cardStyle: {
                      margin: "0px 0px 10px 0px",
                      "border-radius": "12px"
                    },
                    hasPesquisaAvancada: false
                  },
                  on: {
                    search: _vm.handlePesquisa,
                    resetSearch: _vm.resetPesquisa,
                    searchAdvanced: _vm.handlePesquisaAvancada
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "pesquisaAvancada" },
                    [
                      _c("pesquisa-avancada-arrecadacao", {
                        attrs: { filtro: _vm.pesquisaAvancada }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "default-card", attrs: { shadow: "hover" } },
        [
          _c("app-divider-refresh-button", {
            attrs: {
              label: "Listagem de Processos",
              hasButton: true,
              content: "Atualizar processos"
            },
            on: { click: _vm.resetPesquisa }
          }),
          _c("table-generica", {
            attrs: {
              colunas: _vm.colunas,
              botoesAcao: _vm.botoesAcao,
              sortChanged: _vm.sortChanged,
              dados: _vm.processosCadastrados
            }
          }),
          _c("app-paginacao", {
            attrs: { total: _vm.totalCadastros, pagina: _vm.pagina },
            on: { changePage: _vm.changePage }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22c76069", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22c76069","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/gat/GatAguardandoValidacao.vue
// module id = null
// module chunks = 